/* Mascheroni Store – lista dei preferiti nativa (localStorage) */
(function () {
  'use strict';
  var KEY = 'ms_wishlist_v1';
  var EN = (document.documentElement.lang || 'it').toLowerCase().indexOf('en') === 0;
  var T = EN ? {
    add: 'Add to wishlist', remove: 'Remove from wishlist', title: 'Your wishlist',
    empty: 'You have not saved any pieces yet. Tap the heart on a product to find it here.',
    view: 'View the piece', removeBtn: 'Remove', all: 'View the full wishlist', close: 'Close',
    shop: 'Continue shopping', pdpAdd: 'Save to wishlist', pdpSaved: 'Saved to wishlist', sold: 'Sold out'
  } : {
    add: 'Aggiungi ai preferiti', remove: 'Rimuovi dai preferiti', title: 'I vostri preferiti',
    empty: 'Non avete ancora salvato nessun capo. Toccate il cuore su un prodotto per ritrovarlo qui.',
    view: 'Vedi il capo', removeBtn: 'Rimuovi', all: 'Vedi tutti i preferiti', close: 'Chiudi',
    shop: 'Continuate gli acquisti', pdpAdd: 'Salva nei preferiti', pdpSaved: 'Salvato nei preferiti', sold: 'Esaurito'
  };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE_URL = ROOT + 'pages/preferiti';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.25s-7.4-4.5-9.2-9.05C1.6 8.1 3.5 4.5 7.05 4.5c1.95 0 3.35 1.05 4.95 2.95C13.6 5.55 15 4.5 16.95 4.5c3.55 0 5.45 3.6 4.25 6.7-1.8 4.55-9.2 9.05-9.2 9.05z"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var cache = {};

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ms-wishlist:change'));
  }
  function has(h) { return read().some(function (i) { return i.h === h; }); }
  function toggle(h) {
    var list = read();
    if (list.some(function (i) { return i.h === h; })) list = list.filter(function (i) { return i.h !== h; });
    else list.unshift({ h: h, t: Date.now() });
    write(list);
  }
  function removeItem(h) { write(read().filter(function (i) { return i.h !== h; })); }
  function handleFrom(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var n = (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return cur === 'EUR' ? '€' + n : n + ' ' + cur;
  }
  function img(src, w) {
    if (!src) return '';
    var s = String(src);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- pulsanti cuore ---------- */
  function syncButton(b) {
    var on = has(b.getAttribute('data-handle'));
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? T.remove : T.add);
    var lab = b.querySelector('.ms-wl-pdp__label');
    var txt = on ? T.pdpSaved : T.pdpAdd;
    if (lab && lab.textContent !== txt) lab.textContent = txt;
  }
  function syncAll() {
    document.querySelectorAll('[data-ms-wl-toggle]').forEach(syncButton);
    var n = read().length;
    document.querySelectorAll('.ms-wl-count').forEach(function (c) {
      var txt = n > 99 ? '99+' : String(n);
      if (c.textContent !== txt) c.textContent = txt;
      if (n > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
    });
  }
  function makeCardButton(h) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ms-wl-btn';
    b.setAttribute('data-ms-wl-toggle', '');
    b.setAttribute('data-handle', h);
    b.innerHTML = HEART;
    syncButton(b);
    return b;
  }
  function decorateCards(scope) {
    (scope || document).querySelectorAll('.product-card__image-wrapper:not([data-ms-wl])').forEach(function (w) {
      var a = w.querySelector('a[href*="/products/"]');
      var h = a && handleFrom(a.getAttribute('href'));
      if (!h) return;
      w.setAttribute('data-ms-wl', '');
      w.appendChild(makeCardButton(h));
    });
  }
  function decoratePdp() {
    if (!/\/products\//.test(location.pathname)) return;
    var h = handleFrom(location.pathname);
    if (!h) return;
    var forms = document.querySelectorAll('form.main-product-form');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('quick-view-modal')) continue;
      var wrap = f.closest('.product-form') || f;
      if (wrap.parentNode.querySelector('.ms-wl-pdp')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ms-wl-pdp';
      b.setAttribute('data-ms-wl-toggle', '');
      b.setAttribute('data-handle', h);
      b.innerHTML = HEART + '<span class="ms-wl-pdp__label"></span>';
      wrap.insertAdjacentElement('afterend', b);
      syncButton(b);
      return;
    }
  }
  function decorateHeader() {
    document.querySelectorAll('a[href="#hero-wishlist"], a[data-ms-wl-header]').forEach(function (a) {
      if (a.hasAttribute('data-ms-wl-header')) return;
      a.setAttribute('data-ms-wl-header', '');
      a.setAttribute('href', PAGE_URL);
      a.setAttribute('aria-label', T.title);
      a.classList.add('relative');
      var c = document.createElement('span');
      c.className = 'cart-count cart-count--absolute font-body-bolder ms-wl-count';
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('hidden', '');
      a.appendChild(c);
    });
  }

  /* ---------- dati prodotto ---------- */
  function fetchProduct(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 404) return { missing: true };
        if (!r.ok) throw new Error('fetch');
        return r.json();
      })
      .catch(function () { delete cache[h]; return null; });
    return cache[h];
  }
  function loadAll() {
    var list = read();
    return Promise.all(list.map(function (i) { return fetchProduct(i.h); })).then(function (res) {
      var gone = [];
      var items = [];
      res.forEach(function (p, idx) {
        if (p && p.missing) gone.push(list[idx].h);
        else if (p) items.push({ h: list[idx].h, p: p });
      });
      if (gone.length) write(read().filter(function (i) { return gone.indexOf(i.h) === -1; }));
      return items;
    });
  }
  function priceHtml(p) {
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    return '<span class="' + (sale ? 'is-sale' : '') + '">' + money(p.price) + '</span>' +
      (sale ? '<s>' + money(p.compare_at_price) + '</s>' : '');
  }
  function emptyHtml() {
    return '<div class="ms-wl-empty"><p>' + esc(T.empty) + '</p><a class="btn btn--primary" href="' + ROOT + '">' + esc(T.shop) + '</a></div>';
  }

  /* ---------- pannello laterale ---------- */
  var drawer, lastFocus;
  function buildDrawer() {
    if (drawer) return drawer;
    drawer = document.createElement('div');
    drawer.className = 'ms-wl-drawer';
    drawer.setAttribute('hidden', '');
    drawer.innerHTML =
      '<div class="ms-wl-drawer__overlay" data-ms-wl-close></div>' +
      '<aside class="ms-wl-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="MsWlTitle">' +
      '<div class="ms-wl-drawer__head"><h2 id="MsWlTitle" class="ms-wl-drawer__title">' + esc(T.title) + '</h2>' +
      '<button type="button" class="ms-wl-drawer__close" data-ms-wl-close aria-label="' + esc(T.close) + '">' + CLOSE + '</button></div>' +
      '<div class="ms-wl-drawer__body" data-ms-wl-drawer-body></div>' +
      '<div class="ms-wl-drawer__foot" hidden><a class="btn btn--primary" href="' + PAGE_URL + '">' + esc(T.all) + '</a></div>' +
      '</aside>';
    document.body.appendChild(drawer);
    return drawer;
  }
  function renderDrawer() {
    if (!drawer || drawer.hasAttribute('hidden')) return;
    var body = drawer.querySelector('[data-ms-wl-drawer-body]');
    var foot = drawer.querySelector('.ms-wl-drawer__foot');
    if (!read().length) { body.innerHTML = emptyHtml(); foot.setAttribute('hidden', ''); return; }
    if (!body.children.length) body.innerHTML = '<div class="ms-wl-loading" aria-hidden="true"></div>';
    loadAll().then(function (items) {
      if (!items.length) { body.innerHTML = emptyHtml(); foot.setAttribute('hidden', ''); return; }
      foot.removeAttribute('hidden');
      body.innerHTML = items.map(function (it) {
        var p = it.p, url = p.url;
        return '<div class="ms-wl-item">' +
          '<a class="ms-wl-item__img" href="' + esc(url) + '" tabindex="-1">' +
          (p.featured_image ? '<img src="' + esc(img(p.featured_image, 240)) + '" alt="' + esc(p.title) + '" loading="lazy" width="96" height="128">' : '') + '</a>' +
          '<div class="ms-wl-item__info">' +
          '<p class="ms-wl-item__vendor">' + esc(p.vendor) + '</p>' +
          '<a class="ms-wl-item__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
          '<div class="ms-wl-item__price">' + priceHtml(p) + '</div>' +
          (p.available ? '' : '<p class="ms-wl-sold">' + esc(T.sold) + '</p>') +
          '<div class="ms-wl-item__actions"><a href="' + esc(url) + '">' + esc(T.view) + '</a>' +
          '<button type="button" data-ms-wl-remove data-handle="' + esc(it.h) + '">' + esc(T.removeBtn) + '</button></div>' +
          '</div></div>';
      }).join('');
    });
  }
  function openDrawer() {
    buildDrawer();
    lastFocus = document.activeElement;
    drawer.removeAttribute('hidden');
    drawer.querySelector('[data-ms-wl-drawer-body]').innerHTML = '';
    renderDrawer();
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
    document.documentElement.classList.add('ms-wl-lock');
    setTimeout(function () { var c = drawer.querySelector('.ms-wl-drawer__close'); if (c) c.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer || drawer.hasAttribute('hidden')) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ms-wl-lock');
    setTimeout(function () { drawer.setAttribute('hidden', ''); }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- pagina preferiti ---------- */
  function renderPage() {
    var grid = document.querySelector('[data-ms-wl-page]');
    if (!grid) return;
    if (!read().length) { grid.classList.add('is-empty'); grid.innerHTML = emptyHtml(); return; }
    loadAll().then(function (items) {
      if (!items.length) { grid.classList.add('is-empty'); grid.innerHTML = emptyHtml(); return; }
      grid.classList.remove('is-empty');
      grid.innerHTML = items.map(function (it) {
        var p = it.p;
        return '<div class="ms-wl-card"><div class="ms-wl-card__media">' +
          '<a class="ms-wl-card__img" href="' + esc(p.url) + '" tabindex="-1">' +
          (p.featured_image ? '<img src="' + esc(img(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="ms-wl-btn is-active" data-ms-wl-remove data-handle="' + esc(it.h) + '" aria-label="' + esc(T.remove) + '">' + HEART + '</button>' +
          '</div><div class="ms-wl-card__info">' +
          '<p class="ms-wl-item__vendor">' + esc(p.vendor) + '</p>' +
          '<a class="ms-wl-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="ms-wl-item__price">' + priceHtml(p) + '</div>' +
          (p.available ? '' : '<p class="ms-wl-sold">' + esc(T.sold) + '</p>') +
          '</div></div>';
      }).join('');
    });
  }

  /* ---------- eventi ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ms-wl-toggle]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      toggle(t.getAttribute('data-handle'));
      t.classList.remove('ms-wl-pop'); void t.offsetWidth; t.classList.add('ms-wl-pop');
      return;
    }
    var r = e.target.closest && e.target.closest('[data-ms-wl-remove]');
    if (r) { e.preventDefault(); removeItem(r.getAttribute('data-handle')); return; }
    var hd = e.target.closest && e.target.closest('[data-ms-wl-header]');
    if (hd) { e.preventDefault(); e.stopPropagation(); openDrawer(); return; }
    if (e.target.closest && e.target.closest('[data-ms-wl-close]')) { e.preventDefault(); closeDrawer(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('ms-wishlist:change', function () { syncAll(); renderDrawer(); renderPage(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncAll(); renderPage(); } });

  function init() {
    decorateHeader();
    decorateCards(document);
    decoratePdp();
    syncAll();
    renderPage();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorateCards(document); decoratePdp(); decorateHeader(); syncAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MsWishlist = { open: openDrawer, list: read };
})();
